export const general_elements = {
	ERROR_TEXT: {
		value: 'Technical error, please contact game provider or support',
		config: {
			fill: '#FCCED3',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold'
		}
	},
	NOTIFICATION_HEADER: {
		value: 'SESSION EXPIRED',
		config: {
			fill: '#9A98EA',
			fontSize: '38px',
			fontFamily: 'Poppins SemiBold'
		}
	},
	NOTIFICATION_DESC: {
		value:
			'Your session has been expired, please reload the game to continue playing',
		config: {
			fill: '#FFFFFF',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	NOTIFICATION_BTN: {
		value: 'OK',
		config: {
			fill: '#FFFFFF',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	}
};
